import React from "react";
import BreakdownOfPrisonersPunjab from "./chart/BreakdownOfPrisonersPunjab";
import CapacityOfJailsInPunjab from "./chart/CapacityOfJailsInPunjab";
import PrisonersInPunjabMakeUp from "./chart/PrisonersInPunjabMakeUp";
import PrisonPopulationTrend from "./chart/PrisonPopulationTrend";
import UnderTrialPrisonersInPakistan from "./chart/UnderTrialPrisonersInPakistan";

import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import PunjabPrisonsBreakdownYear from "./chart/PunjabPrisonsBreakdownYear";

function PunjabPrisonStatistics() {
  return (
    <div className="py-5">
      <h2 className="text-h-black">Punjab Prison Statistics</h2>
      <div className="row row-cols-1 row-cols-md-4 py-5">
        <div className="col">
          <p className="punjab-static-h">
            <b>Prison Population Trend</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={50644} redraw={true} separator=",">
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                *
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                currently, Year 2022
              </p>
            </div>
          </div>
          <PrisonPopulationTrend />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Operating Rate</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={142.3} redraw={true} decimals={1}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                of its authorized capacity
              </p>
            </div>
          </div>
          <BreakdownOfPrisonersPunjab />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Prison Population in Punjab</b>
          </p>
          <div className="d-flex align-items-end">
            <div>
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={59.1} redraw={true} decimals={1}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                of the total prison population in Pakistan
              </p>
            </div>
          </div>
          <PrisonersInPunjabMakeUp />
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Under-trial Prisoners</b>
          </p>
          <div className="d-flex align-items-end">
            <div className="col">
              <p
                className="m-0"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={68} redraw={true}>
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
            <div className="ms-2">
              <p
                style={{ color: "red", fontSize: "10px", marginBottom: "10px" }}
              >
                of all prisoners are under trial in only Punjab
              </p>
            </div>
          </div>
          <UnderTrialPrisonersInPakistan />
        </div>
      </div>

      <div className="row row-cols-1 row-cols-md-3">
        <div className="col">
          <p className="punjab-static-h">
            <b>Year 2022 Prisons Breakdown</b>
          </p>
          <PunjabPrisonsBreakdownYear />
        </div>
        <div className="col">
          <div>
            <p className="m-0 punjab-static-h">
              <b>TOTAL JAILS</b>
            </p>
            <p
              className="m-0"
              style={{
                fontSize: "38px",
                color: "#000",
                fontFamily: "Abril Fatface",
              }}
            >
              <CountUp end={43} redraw={true}>
                {({ countUpRef, start }) => (
                  <VisibilitySensor onChange={start} delayedCall>
                    <span ref={countUpRef} />
                  </VisibilitySensor>
                )}
              </CountUp>
            </p>
          </div>
          <div>
            <p className="m-0 punjab-static-h">
              <b>CAPACITY</b>
            </p>
            <div className="d-flex align-items-end">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={36806} redraw={true} separator=",">
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </p>
              </div>

              <div className="ms-2">
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                  }}
                >
                  of all prisoners are under trial in only Punjab
                </p>
              </div>
            </div>

            <p className="m-0 punjab-static-h ">
              <b>PRISONERS</b>
            </p>
            <div className="d-flex align-items-end">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={52376} redraw={true} separator=",">
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </p>
              </div>

              <div className="ms-2">
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                  }}
                >
                  by end of Year 2021
                </p>
              </div>
            </div>
            <p className="m-0 punjab-static-h">
              <b>OVERCROWDED JAILS</b>
            </p>

            <div className="d-flex align-items-center">
              <div>
                <p
                  className="m-0"
                  style={{
                    fontSize: "38px",
                    color: "#000",
                    fontFamily: "Abril Fatface",
                  }}
                >
                  <CountUp end={29} redraw={true} separator=",">
                    {({ countUpRef, start }) => (
                      <VisibilitySensor onChange={start} delayedCall>
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                  +
                </p>
              </div>
              <div className="ms-2">
                <p className="m-0">
                  <b>OUT OF 43</b>
                </p>
                <p
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                  }}
                >
                  As per last year statistics
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <p className="punjab-static-h">
            <b>Capacity of Jails in Punjab</b>
          </p>
          <CapacityOfJailsInPunjab />
          <div className="d-flex align-items-end">
            <div>
              <p
                style={{
                  color: "red",
                  fontSize: "11px",
                  marginBottom: "10px",
                }}
              >
                current overcrowding percentage, however, remains
              </p>
            </div>
            <div>
              <p
                className="m-0 ms-2"
                style={{
                  fontSize: "38px",
                  color: "#000",
                  fontFamily: "Abril Fatface",
                }}
              >
                <CountUp end={38} redraw={true} separator=",">
                  {({ countUpRef, start }) => (
                    <VisibilitySensor onChange={start} delayedCall>
                      <span ref={countUpRef} />
                    </VisibilitySensor>
                  )}
                </CountUp>
                %
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PunjabPrisonStatistics;
